module.exports = __webpack_public_path__ + "static/img/logo.2f93494.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/common/logo.png
// module id = 7CIa
// module chunks = 1